import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dbf989c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-file", "data-rank"]
const _hoisted_2 = { class: "chess-board-square__name" }

import { getRank, getFile } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChessSquare',
  props: {
    squareIndex: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'chess-board-square': true,
            'left-edge': _unref(getFile)(props.squareIndex) === 'a',
            'right-edge': _unref(getFile)(props.squareIndex) === 'h',
            'top-edge': _unref(getRank)(props.squareIndex) === 8,
            'bottom-edge': _unref(getRank)(props.squareIndex) === 1,
        }),
    "data-file": _unref(getFile)(props.squareIndex),
    "data-rank": _unref(getRank)(props.squareIndex)
  }, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getFile)(_ctx.squareIndex)) + _toDisplayString(_unref(getRank)(_ctx.squareIndex)), 1)
  ], 10, _hoisted_1))
}
}

})